export const typeLabels = {
  movie: "电影",
  tv: "电视剧",
  variety: "综艺",
};

export const genreOptions = [
  "全部",
  "科幻",
  "悬疑",
  "犯罪",
  "爱情",
  "剧情",
  "动作",
  "冒险",
  "历史",
  "都市",
  "奇幻",
  "古装",
  "家庭",
  "年代",
  "音乐",
  "美食",
  "真人秀",
  "竞技",
  "旅行",
  "推理",
];

export const regionOptions = [
  "全部",
  "中国大陆",
  "美国",
  "英国",
  "法国",
];

export const yearOptions = ["全部", "2025", "2024", "2023"];

export const sortOptions = [
  { label: "按热门", value: "hot" },
  { label: "按最新", value: "newest" },
  { label: "按评分", value: "rating" },
];

export const categoryIntro: Record<string, { title: string; desc: string }> = {
  movie: {
    title: "电影频道",
    desc: "汇聚科幻、悬疑、爱情、历史等多类型精选电影，为你梳理值得一看的佳作。",
  },
  tv: {
    title: "电视剧频道",
    desc: "从都市群像到悬疑刑侦，精选高口碑国产剧集与海外佳作，追剧不迷路。",
  },
  variety: {
    title: "综艺频道",
    desc: "覆盖竞技、美食、音乐、推理等热门综艺类型，轻松解压又有料。",
  },
};